import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import feesAndPaymentApis from "../../api/feesAndPaymentApis";
import {
  GetInvoiceParams,
  Invoice,
  PaginatedInvoices,
} from "../../types/feesAndPaymentType";

interface FeesState {
  invoices: Invoice[];
  isLoading: boolean;
  page: number;
  size: number;
  total: number;
  error: string | null;
}

const initialState: FeesState = {
  invoices: [],
  isLoading: false,
  page: 0,
  size: 20,
  total: 0,
  error: null,
};

export const fetchInvoices = createAsyncThunk<
  PaginatedInvoices,
  GetInvoiceParams
>("fees/fetchInvoices", async (params, { rejectWithValue }) => {
  try {
    const res = await feesAndPaymentApis.getInvoices(params);
    return res.data.data;
  } catch (err: any) {
    return rejectWithValue(err.message);
  }
});

const feesSlice = createSlice({
  name: "fees",
  initialState,
  reducers: {
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setSize(state, action: PayloadAction<number>) {
      state.size = action.payload;
      state.page = 0; // reset page on size change
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.invoices = action.payload.content;
        state.total = action.payload.totalElements;
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setPage, setSize } = feesSlice.actions;
export default feesSlice.reducer;
